import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { Table, TableHeader, TableBody, TableRow, TableHead, } from '@cargomatic/ui';
import { Document } from './Document';
export function DocumentsList({ isOrder, documents, deleteDisabled, onDeleteConfirm, onDeleteDecline, sentDocuments, loading, }) {
    const { t } = useTranslation();
    const entity = isOrder ? 'order' : 'shipment';
    if (loading) {
        return React.createElement(LoadingCircle, { text: t('LOADING') });
    }
    if (!documents || documents.length === 0) {
        return React.createElement("i", null, t('THIS_ENTITY_HAS_NO_DOCUMENTS', { entity }));
    }
    return (React.createElement("div", { className: "overflow-x-auto" },
        React.createElement(Table, { "data-testid": "shipment-documents-table" },
            React.createElement(TableHeader, null,
                React.createElement(TableRow, null,
                    React.createElement(TableHead, { className: "whitespace-nowrap" }, t('DOCUMENT')),
                    React.createElement(TableHead, { className: "whitespace-nowrap" }, t('DATE_one')),
                    React.createElement(TableHead, { className: "whitespace-nowrap" }, t('SIGNATORY')),
                    React.createElement(TableHead, { className: "whitespace-nowrap" }, t('STATUS')),
                    React.createElement(TableHead, { className: "whitespace-nowrap" }, t('USER')),
                    React.createElement(TableHead, null, "\u00A0"))),
            React.createElement(TableBody, null, documents.map((document, index) => (React.createElement(Document, { key: document.id || index, isOrder: isOrder, document: document, deleteDisabled: deleteDisabled, onDeleteConfirm: onDeleteConfirm, onDeleteDecline: onDeleteDecline, isSent: Boolean(sentDocuments.find((doc) => doc.id === document.id)) })))))));
}
